import { colors } from "styles/colors";

type Props = {
  className?: string;
};

export const BabyProductsIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      width="12"
      height="21"
      viewBox="0 0 12 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="1.20117"
        y="9.40015"
        width="9.6"
        height="10.6667"
        rx="1.06667"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinejoin="round"
      />
      <mask
        id="path-2-outside-1_11830_10210"
        maskUnits="userSpaceOnUse"
        x="1.33398"
        y="-0.0666504"
        width="9"
        height="9"
        fill="black"
      >
        <rect fill="white" x="1.33398" y="-0.0666504" width="9" height="9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.14366 3.07189C7.14366 3.53763 6.98754 3.95465 6.74141 4.23468C6.56957 4.37339 6.45781 4.5987 6.45781 4.85306C6.45781 4.89666 6.4611 4.9394 6.4674 4.98101H6.76255C7.81453 4.98101 8.66732 5.8338 8.66732 6.88577C8.66732 7.09616 8.49676 7.26672 8.28637 7.26672H3.71494C3.50454 7.26672 3.33398 7.09616 3.33398 6.88577C3.33398 5.8338 4.18678 4.98101 5.23875 4.98101H5.53423C5.54054 4.9394 5.54383 4.89666 5.54383 4.85306C5.54383 4.59863 5.43201 4.37328 5.2601 4.23457C5.01402 3.95454 4.85794 3.53757 4.85794 3.07189C4.85794 2.61687 5.36962 1.93335 6.0008 1.93335C6.63198 1.93335 7.14366 2.61687 7.14366 3.07189Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.14366 3.07189C7.14366 3.53763 6.98754 3.95465 6.74141 4.23468C6.56957 4.37339 6.45781 4.5987 6.45781 4.85306C6.45781 4.89666 6.4611 4.9394 6.4674 4.98101H6.76255C7.81453 4.98101 8.66732 5.8338 8.66732 6.88577C8.66732 7.09616 8.49676 7.26672 8.28637 7.26672H3.71494C3.50454 7.26672 3.33398 7.09616 3.33398 6.88577C3.33398 5.8338 4.18678 4.98101 5.23875 4.98101H5.53423C5.54054 4.9394 5.54383 4.89666 5.54383 4.85306C5.54383 4.59863 5.43201 4.37328 5.2601 4.23457C5.01402 3.95454 4.85794 3.53757 4.85794 3.07189C4.85794 2.61687 5.36962 1.93335 6.0008 1.93335C6.63198 1.93335 7.14366 2.61687 7.14366 3.07189Z"
        fill="white"
      />
      <path
        d="M6.74141 4.23468L7.41141 5.06466C7.45863 5.02654 7.50251 4.98447 7.54258 4.93888L6.74141 4.23468ZM6.4674 4.98101L5.41279 5.14089C5.49183 5.66229 5.94004 6.04767 6.4674 6.04767V4.98101ZM5.53423 4.98101V6.04767C6.0616 6.04767 6.50981 5.66229 6.58885 5.14088L5.53423 4.98101ZM5.2601 4.23457L4.45885 4.93869C4.49899 4.98437 4.54297 5.02653 4.5903 5.06472L5.2601 4.23457ZM7.54258 4.93888C7.98013 4.44108 8.21032 3.76433 8.21032 3.07189H6.07699C6.07699 3.31092 5.99496 3.46822 5.94024 3.53047L7.54258 4.93888ZM7.52448 4.85306C7.52448 4.909 7.49969 4.9934 7.41141 5.06466L6.0714 3.4047C5.63946 3.75339 5.39115 4.2884 5.39115 4.85306H7.52448ZM7.52202 4.82112C7.52372 4.83237 7.52448 4.84306 7.52448 4.85306H5.39115C5.39115 4.95025 5.39847 5.04644 5.41279 5.14089L7.52202 4.82112ZM6.4674 6.04767H6.76255V3.91434H6.4674V6.04767ZM6.76255 6.04767C7.22542 6.04767 7.60065 6.4229 7.60065 6.88577H9.73398C9.73398 5.24469 8.40363 3.91434 6.76255 3.91434V6.04767ZM7.60065 6.88577C7.60065 6.50706 7.90765 6.20005 8.28637 6.20005V8.33339C9.08587 8.33339 9.73398 7.68526 9.73398 6.88577H7.60065ZM8.28637 6.20005H3.71494V8.33339H8.28637V6.20005ZM3.71494 6.20005C4.09365 6.20005 4.40065 6.50706 4.40065 6.88577H2.26732C2.26732 7.68527 2.91544 8.33339 3.71494 8.33339V6.20005ZM4.40065 6.88577C4.40065 6.4229 4.77588 6.04767 5.23875 6.04767V3.91434C3.59767 3.91434 2.26732 5.24469 2.26732 6.88577H4.40065ZM5.23875 6.04767H5.53423V3.91434H5.23875V6.04767ZM4.47716 4.85306C4.47716 4.84306 4.47791 4.83236 4.47962 4.82113L6.58885 5.14088C6.60317 5.04644 6.61049 4.95025 6.61049 4.85306H4.47716ZM4.5903 5.06472C4.50196 4.99345 4.47716 4.90901 4.47716 4.85306H6.61049C6.61049 4.28825 6.36206 3.75311 5.9299 3.40443L4.5903 5.06472ZM3.79128 3.07189C3.79128 3.76425 4.02141 4.44091 4.45885 4.93869L6.06135 3.53045C6.00662 3.46818 5.92461 3.31089 5.92461 3.07189H3.79128ZM6.0008 0.866683C5.29316 0.866683 4.74116 1.24252 4.403 1.61492C4.07893 1.97181 3.79128 2.5007 3.79128 3.07189H5.92461C5.92461 3.11332 5.91903 3.13861 5.91728 3.14578C5.91535 3.15365 5.9151 3.15166 5.9199 3.14103C5.93039 3.11779 5.95156 3.08297 5.98236 3.04906C6.01307 3.01523 6.03844 2.99863 6.04855 2.99337C6.05643 2.98926 6.03896 3.00002 6.0008 3.00002V0.866683ZM8.21032 3.07189C8.21032 2.5007 7.92267 1.97181 7.5986 1.61492C7.26044 1.24252 6.70844 0.866683 6.0008 0.866683V3.00002C5.96264 3.00002 5.94517 2.98926 5.95305 2.99337C5.96316 2.99863 5.98853 3.01523 6.01924 3.04906C6.05004 3.08297 6.07121 3.11779 6.0817 3.14103C6.0865 3.15166 6.08625 3.15365 6.08432 3.14578C6.08257 3.13861 6.07699 3.11332 6.07699 3.07189H8.21032Z"
        fill={colors.gray900}
        mask="url(#path-2-outside-1_11830_10210)"
      />
      <path
        d="M1.73438 8.33327C1.73438 7.74416 2.21194 7.2666 2.80104 7.2666H9.20104C9.79014 7.2666 10.2677 7.74416 10.2677 8.33327C10.2677 8.92237 9.79015 9.39994 9.20104 9.39994H2.80104C2.21194 9.39994 1.73438 8.92237 1.73438 8.33327Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinejoin="round"
      />
      <path
        d="M2.26758 12.0668H1.73424V13.1334H2.26758V12.0668ZM3.33424 13.1334C3.6288 13.1334 3.86758 12.8946 3.86758 12.6001C3.86758 12.3055 3.6288 12.0668 3.33424 12.0668V13.1334ZM2.26758 13.1334H3.33424V12.0668H2.26758V13.1334Z"
        fill={colors.pink500}
      />
      <path
        d="M2.26758 14.2001H1.73424V15.2667H2.26758V14.2001ZM3.33424 15.2667C3.6288 15.2667 3.86758 15.028 3.86758 14.7334C3.86758 14.4388 3.6288 14.2001 3.33424 14.2001V15.2667ZM2.26758 15.2667H3.33424V14.2001H2.26758V15.2667Z"
        fill={colors.pink500}
      />
      <path
        d="M2.26758 16.3334H1.73424V17.4H2.26758V16.3334ZM3.33424 17.4C3.6288 17.4 3.86758 17.1613 3.86758 16.8667C3.86758 16.5721 3.6288 16.3334 3.33424 16.3334V17.4ZM2.26758 17.4H3.33424V16.3334H2.26758V17.4Z"
        fill={colors.pink500}
      />
    </svg>
  );
};
